// main.js or main.ts
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
/* eslint-disable */ 
import Firmalar from './components/Pages/FirmalarScreen.vue'
import UnderConst from './components/Pages/UnderConst.vue'
import HomeScreen from './components/Pages/HomeScreen.vue'
import AboutScreen from './components/Pages/AboutScreen.vue'
import ServicesScreen from './components/Pages/ServicesScreen.vue'
import ActivitiesScreen from './components/Pages/ActivitiesScreen.vue'
import InformationScreen from './components/Pages/InformationScreen.vue'
import DuyuruScreen from './components/Pages/DuyuruScreen.vue'
import '@fortawesome/fontawesome-free/css/all.css'
import KurucularScreen from './components/Pages/KurucularScreen.vue'
import KurulScreen from './components/Pages/KurulScreen.vue'
import TesekkurScreen from './components/Pages/TesekkurScreen.vue'
import Taziye from './components/Pages/TaziyeScreen.vue'
import FirmaDetayScreen from './components/Pages/FirmaDetayScreen.vue'
import ToolsScreen from './components/Pages/ToolsScreen.vue'
import ToplantiNotlari from './components/Pages/ToplantiNotlari.vue'
import VefatScreen from './components/Pages/VefatScreen.vue'
import DuyuruScreen2 from './components/Pages/DuyuruScreen2.vue'
import DistrictScreen from './components/Pages/DistrictScreen.vue'
import DISTRICTS from './data/districts'

if (window.location.hash.startsWith('#/')) {
  const cleanPath = window.location.hash.slice(1)
  window.history.replaceState(null, '', cleanPath)
}

const routes = [
  { path: '/', component: HomeScreen },
  { path: '/firmalar', component: Firmalar },
  { path: '/ilanlar', component: UnderConst },
  { path: '/hakkimizda', component: AboutScreen },
  { path: '/anasayfa', component: HomeScreen },
  { path: '/hizmetlerimiz', component: ServicesScreen },
  { path: '/information', redirect: '/sss' },
  { path: '/sss', component: InformationScreen },
  { path: '/etkinlikler', component: ActivitiesScreen },
  { path: '/kurucular', component: KurucularScreen },
  { path: '/kurullar', component: KurulScreen },
  { path: '/tesekkur', component: TesekkurScreen },
  { path: '/duyuru', component: DuyuruScreen },
  { path: '/taziye', component: Taziye },
  { path: '/toplanti', component: ToplantiNotlari },
  { path: '/vefat', component: VefatScreen },
  { path: '/tools', component: ToolsScreen },
  { path: '/duyuru2', component: DuyuruScreen2 },
  { path: '/ilceler/:slug', component: DistrictScreen },
  {
    path: '/firma/:slug', component: FirmaDetayScreen
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: UnderConst },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top
    return { top: 0 }
  }
})

const defaultTitle = "Ankara Ağrılılar Derneği | Ankara'daki Ağrılılar, Doğubayazıtlılar ve Patnoslular"
const defaultDescription = "Ankara Ağrılılar Derneği; Ankara'da yaşayan Ağrılıları, Doğubayazıtlıları, Patnosluları ve tüm Ağrı ilçelerinden hemşehrilerimizi ortak dayanışma çatısında buluşturur."
const defaultKeywords = "Ankara Ağrılılar Derneği, Ankara Ağrılılar, Ankara'daki Ağrılılar, Ağrılılar Ankara, Ankara Doğubayazıtlılar, Ankara Patnoslular, Ankara Diyadinliler, Ankara Eleşkirtililer, Ankara Tutaklılar, Ankara Taşlıçaylılar, Ankara Hamurlular"

const routeMeta = {
  '/anasayfa': {
    title: "Ankara Ağrılılar Derneği | Ankara'daki Ağrılılar",
    description: "Ankara Ağrılılar Derneği; Ankara'da yaşayan Ağrılıları, Ağrı ilçe topluluklarını, aileleri, gençleri ve esnafları dayanışma çatısında buluşturur.",
    keywords: defaultKeywords
  },
  '/hakkimizda': {
    title: "Hakkımızda | Ankara Ağrılılar Derneği ve Ağrı İlçe Hemşehri Ağı",
    description: "Ankara Ağrılılar Derneği hakkında bilgi alın. Ankara'daki Ağrılılar, Doğubayazıtlılar, Patnoslular, Diyadinliler, Eleşkirtililer, Tutaklılar, Taşlıçaylılar ve Hamurlular için dayanışma çatısı.",
    keywords: "Ankara Ağrılılar Derneği hakkımızda, Başkent Ağrılılar Derneği, Ankara Ağrı derneği, Ankara Doğubayazıtlılar, Ankara Patnoslular, Ankara Diyadinliler, Ankara Eleşkirtililer, Ankara Tutaklılar, Ankara Taşlıçaylılar, Ankara Hamurlular"
  },
  '/etkinlikler': {
    title: "Etkinlikler | Ankara Ağrılılar Derneği",
    description: "Ankara Ağrılılar Derneği etkinlikleri, piknik, toplantı, sosyal destek, kültürel buluşma ve hemşehri dayanışma faaliyetleri.",
    keywords: "Ankara Ağrılılar etkinlikleri, Ağrılılar piknik Ankara, Ankara Ağrılılar toplantı, hemşehri etkinlikleri Ankara, kültürel etkinlikler"
  },
  '/firmalar': {
    title: "Firmalar | Ankara'daki Ağrılı Firmalar ve Esnaflar",
    description: "Ankara'daki Ağrılı firmalar, hemşehri esnaflar, hizmet veren işletmeler ve dernek dayanışma ağı içinde yer alan firmalar.",
    keywords: "Ankara Ağrılı firmalar, Ağrılı esnaflar Ankara, Ankara Ağrılı işletmeler, hemşehri firmaları Ankara"
  },
  '/kurucular': {
    title: "Kurucular | Ankara Ağrılılar Derneği",
    description: "Ankara Ağrılılar Derneği kurucuları ve derneğin kuruluşunda emeği geçen hemşehrilerimiz.",
    keywords: "Ankara Ağrılılar Derneği kurucuları, Başkent Ağrılılar Derneği kurucular, AĞ-DER kurucular"
  },
  '/kurullar': {
    title: "Kurullar | Ankara Ağrılılar Derneği Çalışma ve İlçe Temsil Kurulları",
    description: "Ankara Ağrılılar Derneği çalışma kurulları, sosyal destek ekipleri ve Ağrı Merkez, Patnos, Doğubayazıt, Diyadin, Eleşkirt, Tutak, Taşlıçay, Hamur ilçe temsil kurulları.",
    keywords: "Ankara Ağrılılar Derneği kurulları, Ağrı ilçe temsil kurulları Ankara, Ankara Patnos temsil kurulu, Ankara Doğubayazıt temsil kurulu, sosyal destek kurulu, gençlik eğitim kurulu"
  },
  '/sss': {
    title: "Sıkça Sorulan Sorular | Ankara Ağrılılar Derneği",
    description: "Ankara Ağrılılar Derneği sıkça sorulan sorular sayfası. Üyelik, WhatsApp grubu, dernek adresi, telefon, konum, bağış ve resmi hesap bilgileri.",
    keywords: "Ankara Ağrılılar Derneği SSS, Ankara Ağrılılar iletişim, Ankara Ağrılılar WhatsApp grubu, Başkent Ağrılılar Derneği hesap bilgileri, Ağrılılar derneği adres"
  }
}

const setMeta = (selector, content, attribute = 'name') => {
  let element = document.head.querySelector(`meta[${attribute}="${selector}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, selector)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

const setCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

router.afterEach((to) => {
  const district = to.path.startsWith('/ilceler/')
    ? DISTRICTS.find((item) => item.slug === to.params.slug)
    : null
  const pageMeta = routeMeta[to.path]

  const title = district
    ? `${district.communityName} | Ankara Ağrılılar Derneği`
    : pageMeta?.title || defaultTitle
  const description = district
    ? `${district.communityName} sayfası; Ankara'da yaşayan ${district.name} kökenli Ağrılı hemşehrilerimizi ilçe dernekleriyle dayanışma içinde ortak çatıya davet eder.`
    : pageMeta?.description || defaultDescription
  const keywords = district
    ? [...district.seoTerms, district.communityName, `${district.name} hemşehrileri Ankara`, 'Ankara Ağrılılar Derneği'].join(', ')
    : pageMeta?.keywords || defaultKeywords
  const canonicalPath = district ? `/ilceler/${district.slug}` : (to.path === '/' ? '/' : to.path)
  const canonicalUrl = `https://ankaraagrililardernegi.com${canonicalPath}`

  document.title = title
  setMeta('description', description)
  setMeta('keywords', keywords)
  setMeta('og:title', title, 'property')
  setMeta('og:description', description, 'property')
  setMeta('og:url', canonicalUrl, 'property')
  if (district) {
    setMeta('og:image', district.image.startsWith('http') ? district.image : `https://ankaraagrililardernegi.com${district.image}`, 'property')
  }
  setCanonical(canonicalUrl)
})

const app = createApp(App)
app.use(router)
app.mount('#app')
